import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { IdToken } from './IdTokenExtension';

export const IdTokenFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'IdToken',
    component: IdToken
  }),
);